import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { archiveBuilding, setBuildingsRefresh } from '../../../store/actions/buildings.actions';
import { showMessage } from '../../../store/actions/messages.actions';
import { placeWritePermission } from '../../../store/selectors/account.selector';
import store from '../../../store/store';

const BuildingArchiveDialog = ({ handleClose, ...props }) => {
  const dispatch = useDispatch();
  const { action1, actionId1, action2, actionId2 } = useParams();

  const editPermission = useSelector(placeWritePermission);

  const buildings = useSelector((state) => state.buildings.list);
  const [buildingSelected, setBuildingSelected] = useState({});
  const [archiveDialog, setArchiveDialog] = useState(false);

  // state effect
  useEffect(() => {
    let unmounted = false;
    const buildingFromList = actionId1 && (buildings.find((item) => item.id === actionId1));
    if (action1 === 'archive') {
      setArchiveDialog(true);
    } else {
      setArchiveDialog(false);
    }
    if (action1 === 'archive' && actionId1) {
      setBuildingSelected({
        ...buildingFromList,
      });
    }
    return () => {
      unmounted = true;
    };
  }, [action1, action2, actionId1, actionId2, buildings]);

  const onArchiveBuilding = async () => {
    try {
      await store.dispatch(archiveBuilding(actionId1));
      dispatch(showMessage({ open: true, text: 'Дом успешно архивирован', severity: 'success' }));
      handleClose(null, 'success');
      setTimeout(() => dispatch(setBuildingsRefresh()), 500);
    } catch (error) {
      console.log(error);
      dispatch(showMessage({ open: true, text: `Не удалось архивировать. ${error.message}`, severity: 'error' }));
    }
  };

  return (
    <>
      {/* archive dialog */}
      <Dialog {...props} open={archiveDialog} onClose={handleClose} disableRestoreFocus PaperProps={{ sx: { minWidth: '350px' } }}>
        <DialogTitle>
          <Box sx={{ fontSize: '22px' }}>
            Отправить в архив?
          </Box>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: '8px' }}>
          <Typography
            color="textSecondary"
            variant="body1"
          >
            <span>Дом по адресу </span>
            <strong>{buildingSelected.address}</strong>
            <span> будет отправлен в архив</span>
          </Typography>
          <Grid
            container
            justifyContent="space-between"
            spacing={2}
            sx={{
              pb: 2,
              pt: 4,
            }}
          >
            <Grid
              item
            >
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={handleClose}
              >
                Отменить
              </Button>
            </Grid>
            <Grid
              item
            >
              {editPermission && (
                <Button
                  variant="contained"
                  color="purple"
                  fullWidth
                  onClick={onArchiveBuilding}
                >
                  Архивировать
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

BuildingArchiveDialog.propTypes = {
  handleClose: PropTypes.func,
};

BuildingArchiveDialog.defaultProps = {
  handleClose: null,
};

export default BuildingArchiveDialog;
